var map = {
	"./1.png": 6843,
	"./10.png": 1746,
	"./2.png": 3048,
	"./3.png": 5258,
	"./4.png": 6285,
	"./5.png": 4049,
	"./6.png": 194,
	"./7.png": 7261,
	"./8.png": 7174,
	"./9.png": 1008
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2041;